'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import * as UrlPathParams from '../constants/UrlPathParams';

var GoodTileLink = function GoodTileLink(_ref) {
  var goodUrlToken = _ref.goodUrlToken,
      rest = _objectWithoutProperties(_ref, ["goodUrlToken"]);

  return React.createElement(Link, Object.assign({}, rest, {
    style: {
      textDecoration: 'none'
    },
    to: "/" + UrlPathParams.DIRECTORY_PAGE_PATH + "/" + goodUrlToken
  }));
};

GoodTileLink.propTypes = {
  goodUrlToken: PropTypes.string.isRequired
};
export default GoodTileLink;